import React, { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";
import { allOps } from "@/lib/offlineQueue";

// Shared defect_id -> number of queued (not yet uploaded) photos.
let counts = {};
const subs = new Set();
let started = false;

async function recount() {
  const next = {};
  try {
    for (const op of await allOps()) {
      if (op.op !== "create" || op.type !== "form" || op.entityType !== "photos" || !op.parentId) continue;
      next[op.parentId] = (next[op.parentId] || 0) + 1;
    }
  } catch (_) {}
  counts = next;
  subs.forEach((fn) => fn(counts));
}

function usePendingCounts() {
  const [c, setC] = useState(counts);
  useEffect(() => {
    subs.add(setC);
    if (!started) { started = true; window.addEventListener("offline-queued", recount); }
    recount();
    return () => { subs.delete(setC); };
  }, []);
  return c;
}

export function usePendingPhotoTotal() {
  return Object.values(usePendingCounts()).reduce((a, b) => a + b, 0);
}

export default function PendingPhotoBadge({ defectId }) {
  const n = usePendingCounts()[defectId] || 0;
  if (!n) return null;
  return (
    <span data-testid={`defect-pending-photos-${defectId}`} title={`${n} Foto(s) noch nicht übertragen`}
      className="inline-flex items-center gap-1 rounded-full bg-amber-500 text-white text-[10px] font-semibold px-1.5 py-0.5 shrink-0">
      <CloudOff className="h-3 w-3" />{n}
    </span>
  );
}
